<div class="team-card">
  <div class="team-card__thumb">
    <img *ngIf="!teamCard?.profileThumbImg?.url" src="../../../assets/images/user-placeholder-thumb.svg" alt="{{teamCard?.name}}" />
    <img *ngIf="teamCard?.profileThumbImg?.url" src="{{teamCard?.profileThumbImg?.url}}" alt="{{teamCard?.name}}" />
  </div>
  <h3 class="team-card__name">{{teamCard?.name}}</h3>
  <p class="team-card__designation text-14 mb-0">({{teamCard?.designation}})</p>
</div>
